import React from 'react';
import {
  Button,
  Dropdown,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import _ from 'underscore';
import cn from 'classnames';

import { Skeletons } from 'ui/components/skeleton';
import { Order } from 'services/action';
import DispatchForm from '../dispatch/form';
import { FormPayment } from '../form';
import PDFInvoice from 'ui/screens/authorized/pdf/invoice';
import { FormUpdatePricing } from '../form/price';
import { isNotClient } from 'utilities/common';

const initialState = {
  privilege: null,
  showVoid: false,
  showDispatch: false,
  showRecreate: false,
  showPayment: false,
  showDelete: false,
  showPrice: false,
};

export const Action = ({ data, onSubmit }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const [
    {
      showVoid,
      showRecreate,
      privilege,
      showDispatch,
      showPayment,
      showDelete,
      showPrice,
    },
    setState,
  ] = React.useState(initialState);

  const $getPriviledge = async () => {
    const payload = {};

    const delivery = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.delivery',
    });

    const manifest = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    if (pricing) {
      payload.pricing = pricing;
    }
    if (delivery) {
      payload.delivery = delivery;
    }

    if (manifest) {
      payload.manifest = manifest;
    }

    setState((prevState) => ({ ...prevState, privilege: payload }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showVoid: false,
      showDispatch: false,
      showDispute: false,
      showRecreate: false,
      showDelete: false,
      showPrice: false,
    }));
  };

  const $handleVoid = async () => {
    const req = await Dispatch(Order.$void(data?.id));
    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  const $handleDelete = async () => {
    const req = await Dispatch(Order.$delete(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      History.replace('/order');
    }
  };

  const $handleReorder = async () => {
    const req = await Dispatch(Order.$reorder(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      History.replace(`/order/${req?.data?.id}`);
    }
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const StandardAction = () => {
    return (
      data?.document_status === 'new' && (
        <>
          {(privilege?.delivery?.action === 'manage' ||
            !Session?.privileges) && data?.manifest_id === '' && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
            >
              <Link
                to={`/order/${data?.id}/update`}
                className={cn('btn btn-primary px-2')}
              >
                <Fi.FiEdit size="17" />
              </Link>
            </OverlayTrigger>
          )}

          {data?.type === 'ftl' &&
            (!Session?.privileges ||
              privilege?.manifest?.action === 'manage') && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-top`}>Dispatch</Tooltip>}
              >
                <button
                  className={cn('btn btn-secondary px-2')}
                  onClick={() =>
                    setState((prevState) => ({
                      ...prevState,
                      showDispatch: true,
                    }))
                  }
                >
                  <Fi.FiGitMerge size="17" />
                </button>
              </OverlayTrigger>
            )}
        </>
      )
    );
  };

  const SettingAction = () => {
    return privilege?.delivery?.action === 'manage' || !Session?.privileges ? (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0 justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Pengaturan</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiSettings size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-0 rounded-2">
          {(data?.document_status === 'delivered' ||
            data?.document_status === 'partial_paid' ||
            data?.document_status === 'paided' ||
            data?.document_status === 'paid') && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  border-bottom"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showRecreate: true }))
              }
            >
              <Fi.FiCopy size={15} color="#202020" className="me-2" />
              Buat ulang
            </div>
          )}

          {data?.document_status === 'new' && (
            <>
              <div
                className="dropdown-item d-flex align-items-center text-danger  cursor-pointer  "
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    showVoid: true,
                  }))
                }
              >
                <Fi.FiX size={15} color="#FF1818" className="me-2" />
                Batalkan order
              </div>
              <div
                className="dropdown-item d-flex align-items-center text-danger  cursor-pointer  "
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    showDelete: true,
                  }))
                }
              >
                <Fi.FiTrash2 size={15} color="#FF1818" className="me-2" />
                Hapus order
              </div>
            </>
          )}

          {data?.document_status === 'draft' && (
            <>
              <div
                className="dropdown-item d-flex align-items-center cursor-pointer  "
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    showNew: true,
                  }))
                }
              >
                <Fi.FiX size={15} color="#202020" className="me-2" />
                Aktifkan Order
              </div>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    ) : null;
  };

  const ActionPayment = () => {
    return (privilege?.delivery?.action === 'manage' || !Session?.privileges) &&
      (data?.payment_status === 'unpaid' ||
        data?.payment_status === 'partial_paid') &&
      data?.total_charges > 0 &&
      data?.document_status !== 'void' ? (
      <>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Buat Pembayaran</Tooltip>}
        >
          <button
            className={cn('btn btn-secondary px-2')}
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                showPayment: true,
              }))
            }
          >
            <Fi.FiCreditCard size="17" />
          </button>
        </OverlayTrigger>

        <Dropdown
          className="d-inline p-0 m-0 split-carret"
          as="div"
          align="end"
        >
          <Dropdown.Toggle
            id="dropdown-autoclose-true"
            className="d-flex p-0 justify-content-between "
          >
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Invoice</Tooltip>}
            >
              <div
                className=" border-end border-light"
                style={{ padding: '4.4px 8px' }}
              >
                <Fi.FiClipboard size="17" className=" border-end" />
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="py-0 rounded-2">
            <PDFInvoice data={data} />

            <Link
              to={`/print/invoice/${data?.id}`}
              className="dropdown-item d-flex align-items-center cursor-pointer  "
              target="_blank"
            >
              <Fi.FiPrinter size={15} color="#202020" className="me-2" />
              Print Invoice
            </Link>
          </Dropdown.Menu>
        </Dropdown>
      </>
    ) : null;
  };

  if (isNotClient(Session?.client?.id, data?.client?.id)) {
    return null
  }

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {StateLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          {data?.document_status !== 'voided' && (
            <>
              <StandardAction />
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-top`}>Print Order</Tooltip>}
              >
                <Link
                  to={`/print/order/${data?.id}`}
                  className="btn btn-secondary px-2"
                  target="_blank"
                >
                  <Fi.FiPrinter size={17} />
                </Link>
              </OverlayTrigger>

              {data?.type === 'ftl' &&
              (!Session?.privileges ||
                privilege?.pricing?.action === 'manage') ? (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id={`tooltip-top`}>Perbaharui Harga</Tooltip>
                  }
                >
                  <button
                    className={cn('btn btn-primary px-2')}
                    onClick={() =>
                      setState((prevState) => ({
                        ...prevState,
                        showPrice: true,
                      }))
                    }
                  >
                    <Fi.FiCreditCard size={17} />
                  </button>
                </OverlayTrigger>
              ) : null}

              {Session?.client?.company_type === 'carrier' && <ActionPayment />}
              {data?.document_status !== 'process' && <SettingAction />}
            </>
          )}
        </>
      )}

      {/* modal showVoid */}
      <Modal
        show={showVoid}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dibatalkan tidak bisa diproses ulang
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleVoid}
                disabled={StateForm?.loading}
              >
                Konfirmasi
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal showRecreate */}
      <Modal
        show={showRecreate}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleReorder}
                disabled={StateForm?.loading}
              >
                Konfirmasi
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal showDispatch */}
      <Modal
        show={showDispatch}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header className="text-center d-block p-0" closeButton>
          <div className="py-3">
            <div className="fw-bold fs-6">Dispatch Order</div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <DispatchForm
            data={data}
            onCreate={() => {
              onSubmit();
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>

      {/* payment */}
      <Modal
        show={showPayment}
        onHide={() =>
          setState((prevState) => ({ ...prevState, showPayment: false }))
        }
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Buat Pembayaran</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormPayment
            id={data?.id}
            onSubmit={() => {
              onSubmit();
              setState((prevState) => ({ ...prevState, showPayment: false }));
            }}
          />
        </Modal.Body>
      </Modal>

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal update harga */}
      <Modal
        show={showPrice}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <h3 className="text-center mb-3">Update harga</h3>
          <FormUpdatePricing
            data={data}
            onSubmit={() => {
              onSubmit();
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
